import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

const DOCS_ICON_LIST:any = {
  PDF: 'assets/icons/DOCUMENT_TYPE_PDF.svg',
  DOC: 'assets/icons/DOCUMENT_TYPE_DOC.svg',
  DOCX: 'assets/icons/DOCUMENT_TYPE_DOC.svg',
  XLS: 'assets/icons/DOCUMENT_TYPE_XLS.svg',
  XLSX: 'assets/icons/DOCUMENT_TYPE_XLS.svg',
  PPT: 'assets/icons/DOCUMENT_TYPE_PPT.svg',
  PPTX: 'assets/icons/DOCUMENT_TYPE_PPT.svg',
  RAR: 'assets/icons/DOCUMENT_TYPE_ZIP.svg',
  ZIP: 'assets/icons/DOCUMENT_TYPE_ZIP.svg',
  HTML: 'assets/icons/DOCUMENT_TYPE_HTML.svg',
  TXT: 'assets/icons/DOCUMENT_TYPE_TXT.svg',
  JPG: 'assets/icons/DOCUMENT_TYPE_JPG.svg',
  PNG: 'assets/icons/DOCUMENT_TYPE_PNG.svg',
  SVG: 'assets/icons/DOCUMENT_TYPE_SVG.svg',
  AI: 'assets/icons/DOCUMENT_TYPE_AI.svg',
}

@Component({
  selector: 'app-upload-file-input',
  templateUrl: './upload-file-input.component.html',
  styleUrls: ['./upload-file-input.component.scss']
})
export class UploadFileInputComponent implements OnInit {

  @ViewChild('inputFile') inputFileRef!: ElementRef;

  @Input() label!:string;
  @Input() media!:any;
  @Output() addFileCalled = new EventEmitter<any>();
  @Output() removeFileCalled = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  async changeListenerDoc(event:any): Promise<void> {
    try {
      let file = event.target.files[0];
      let originData = await this.fileToBase64(file);

      this.media = {
        mimetype: file.type,
        type: 'DOCUMENT',
        fileName: file.name,
        base64: originData
      };

      this.addFileCalled.emit(this.media);
      
    } catch (error) {
      console.error(error);
    } 
  }

  public async fileToBase64(file:any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async _event => {
        resolve(reader.result);
      }
      reader.onerror = async _event => {
        reject(reader.error);
      }

      reader.readAsDataURL(file);

    });
  }

  addFile(){
    this.inputFileRef.nativeElement.click();
  }

  removeFile(){
    this.removeFileCalled.emit();
    this.media = null;
  }

  getFileExt():string {
    if(this.media){
      let tabExt = (this.media.fileName).split('.');
      let ext = String(tabExt[tabExt.length - 1]).toUpperCase() || 'PDF';
      return DOCS_ICON_LIST[ext];
    }else{
      return '';
    }
  }

}
